var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSection = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.75 5c0-.966.784-1.75 1.75-1.75h9c.966 0 1.75.784 1.75 1.75v6a1.75 1.75 0 0 1-1.75 1.75h-9A1.75 1.75 0 0 1 1.75 11V5Zm1.75-.25a.25.25 0 0 0-.25.25v6c0 .138.112.25.25.25H6v-6.5H3.5Zm9 6.5h-5v-2.5h5.25V11a.25.25 0 0 1-.25.25Zm.25-4V5a.25.25 0 0 0-.25-.25h-5v2.5h5.25Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSection);
export default ForwardRef;